import React from "react";
import "./Login.css";
import iHubLogo from "../images/ILH-HORIZONTAL-FULL-COLOR.jpg";
import { useAuth } from "react-oidc-context";
const Login = () => {
  const auth = useAuth();
  const currentUrl = window.location.href;

  return (
    <div className="login-layout">
      <div className="login-container">
        <img src={iHubLogo} alt="Interlogic Hub Logo" className="login-logo" />
        <h2 className="login-title">Log in</h2>
        <div className="login-body">
          <form className="login-form">
            <button
              className="login-button"
              onClick={() =>
                auth.signinRedirect({
                  redirect_uri: currentUrl,
                })
              }
            >
              Log in with cognito
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
